import { Material } from "../interfaces/material.interface";
import { User } from "../interfaces/UserInterface";
import { usePreferredSessionStorage } from "@/composables/usePreferedSessionStorage";
import { Language } from "@/types";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useNavigatorLanguage } from "@vueuse/core";
import type { MenuItem } from "primevue/menuitem";
import { useWebSocketsStore } from "./websockets.store";
import { useWorkflowsStore } from "./workflows.store";
import { disconnectSocket } from "@/utils/http-common";

const browserLanguage = useNavigatorLanguage();

const availableLanguages: Language[] = [
  { locale: "en", code: "GB", name: "English" },
  { locale: "ca", code: "ES-CA", name: "Catalan" },
  { locale: "es", code: "ES", name: "Spanish" },
  { locale: "it", code: "IT", name: "Italian" },
];

export const useMainStore = defineStore("main", {
  state: () => ({
    availableLanguages: availableLanguages,
    preferedLanguage: usePreferredSessionStorage<Language>(`preferedLanguage`, {} as Language),
    companyAlias: "",
    expandAll: ref(false),
    rememberMe: false,
    companyId: "",
    companyName: "",
    goBackLink: "",
    goBackName: "",
    errorMessage: "",
    items: ref([{}] as MenuItem[]),
    menuTitle: ref(""),
    selectedMaterials: {} as Material,
    showSideBar: ref(false),
    storageRef: "",
    toastMessage: { message: "", severity: "" },
    user: usePreferredSessionStorage<User>(`user`, {} as User),
    multipleUsers: usePreferredSessionStorage<User[]>(`multipleUsers`, []),
    userId: "",
    userToken: "",
    visibleAddNewMaterialsDialog: ref(false),
    isEditing: ref(false),
    event: null as any,
  }),
  getters: {
    getUserId(): any {
      return localStorage.getItem("userId") ? localStorage.getItem("userId") : this.userId;
    },
    userInitials(): string {
      if (!this.user || !this.user.name) return "";
      return this.user.name
        .split(" ")
        .map((word: string) => word[0])
        .join("");
    },
  },
  actions: {
    getUserToken(): any {
      if (sessionStorage.getItem("userToken")) this.userToken = sessionStorage.getItem("userToken") || "";
      else if (localStorage.getItem("userToken")) this.userToken = localStorage.getItem("userToken") || "";
    },
    setUserToken(userToken: string) {
      this.userToken = userToken;
      sessionStorage.setItem("userToken", userToken);
    },
    setUserId(userId: string) {
      this.userId = userId;
      sessionStorage.setItem("userId", userId);
    },
    logout() {
      const webSocketsStore = useWebSocketsStore();
      localStorage.removeItem("userToken");
      sessionStorage.removeItem("userToken");
      
      const workflowsStore = useWorkflowsStore();
      workflowsStore.selectedStageId = 0;
      localStorage.removeItem("selectedStageId");
      
      this.userToken = "";
      disconnectSocket();
    },

    setDefaultLanguage() {
      const defaultLang = availableLanguages.find((lang) => lang.locale === browserLanguage.language.value) || availableLanguages[0];
      this.preferedLanguage = defaultLang;
    },
  },
});
